/** Created by azhou on 2019/4/1.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col">{{Itemize.type==1?'企业':'个人'}}</li>
      <li class="w-50 list-item-col">{{Itemize.truename}}</li>
      <li class="w-50 list-item-col">{{Itemize.bank_name}}</li>
      <li class="w-50 list-item-col">{{Itemize.branch}}</li>
      <li class="w-50 list-item-col">{{Itemize.bank_card}}</li>
      <li class="w-50 list-item-col">{{Itemize.remark|| '无'}}</li>
  </ul>
</template>

<script>

  export default {
    name: 'ItemizeBankcard',
    props:{
      Itemize:{}
    }
  }
</script>
